import type {
  TWellLogsSerializedInternalState,
  WellLogsWidgetEntity,
} from 'src/pages/dashboard/features/well-logs-widget/WellLogsWidget.entity';
import type { TSerializedWidgetTemplate } from 'src/pages/dashboard/features/workspace/Workspace.store';

export function serializeWellLogsTemplate(widget: WellLogsWidgetEntity): TSerializedWidgetTemplate {
  const internalState: TWellLogsSerializedInternalState = {
    wellIndexType: widget.wellIndexType,
    isEditMode: false,
    wellId: null,
    stateParams: {
      wellboreId: widget.stateParams.wellboreId,
      autoScroll: widget.stateParams.autoScroll,
      trackInfoVisible: widget.stateParams.trackInfoVisible,
      infoPanels: widget.stateParams.infoPanels,
      timeZone: widget.stateParams.timeZone,
      zoom: widget.stateParams.zoom,
      indexScroll: widget.stateParams.indexScroll,
      logsFilter: widget.stateParams.logsFilter,
      scaleDepthUnit: widget.stateParams.scaleDepthUnit,
      marks: widget.stateParams.marks,
      showComments: widget.stateParams.showComments,
      showDepthBitMarker: widget.stateParams.showDepthBitMarker,
      showDepthBitLine: widget.stateParams.showDepthBitLine,
      scaleDepthIndex: widget.stateParams.scaleDepthIndex,
      enabledScaleDepthIndexes: widget.stateParams.enabledScaleDepthIndexes,
    },
  };

  return {
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    internalState,
  };
}
